module.exports = __webpack_public_path__ + "static/media/kaha-bath-gedara.b24c7924.png";